<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="isSZGK()" :attributes="takarek"/>

            <BnFormField v-if="isSZGK()" :attributes="szakszervezet"/>

            <BnFormField v-if="isSZGK()" :attributes="partner"/>

            <BnFormField v-if="isSZGK()" :attributes="egyuttcasco"/>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';

export default {
    name: 'KedvezmenyekB4',
    components: {
        BnFormField,
        KedvezmenyekBase,
    },
    mixins: [Kedvezmeny],
    computed: {
        // TODO többi attribute-ot is computedba rakni
        egyuttcasco() {
            return {
                type: 'checkbox',
                label: 'CASCO együttkötési kedvezmény',
                mezo: 'signal_egyuttcasco',
                path: 'kedvezmenyekbiztosito.4.egyuttcasco',
                visible: true,
                editable: !this.disabled && !this.egyuttkotve,
                rules: [],
                help: true,
                change: this.shouldRecalc,
            };
        },
        partner() {
            return {
                type: 'checkbox',
                label: 'Partner kedvezmény',
                mezo: 'signal_partner',
                path: 'kedvezmenyekbiztosito.4.partner',
                visible: true,
                editable: !this.disabled && !this.egyuttkotve,
                rules: [],
                help: true,
                change: this.shouldRecalc,
            };
        },
    },
    data() {
        return {
            takarek: {
                type: 'checkbox',
                label: 'Díjfizetés a Signal Biztosítóval partner megállapodásban lévő pénzintézet folyószámlájáról',
                mezo: 'signal_takarek',
                path: 'kedvezmenyekbiztosito.4.takarek',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                change: this.shouldRecalc,
            },
            szakszervezet: {
                type: 'checkbox',
                label: 'Szakszervezeti kedvezmény',
                mezo: 'signal_szakszervezet',
                path: 'kedvezmenyekbiztosito.4.szakszervezet',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                change: this.shouldRecalc,
            },
            coop: {
                type: 'checkbox',
                label: 'Coop klub törzsvásárlói kedvezmény',
                mezo: 'signal_coop',
                path: 'kedvezmenyekbiztosito.4.coop',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                change: this.shouldRecalc,
            },
            tobbszerzodes: {
                type: 'select',
                label: 'Signal Iduna Zrt.-nél lévő egyéb szerződések',
                mezo: 'signal_tobbszerzodes',
                path: 'kedvezmenyekbiztosito.4.tobbszerzodes',
                visible: true,
                editable: !this.disabled,
                rules: [],
                help: true,
                change: this.shouldRecalc,
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {
                        key: 0,
                        value: 'Nincs',
                    },
                    {
                        key: 1,
                        value: '1 db',
                    },
                    {
                        key: 2,
                        value: '2 db',
                    },
                    {
                        key: 3,
                        value: '3 db',
                    },
                    {
                        key: 4,
                        value: '4 db',
                    },
                ],
            },
        };
    },
};
</script>
